<section class="text-info__section">
  <div class="text-info__container">
    <div class="text-info__text">
      <h2 *ngIf="title" class="text-info__text__title" [bindHTML]="title"></h2>
      <div *ngIf="description" class="text-info__text__description" [bindHTML]="description"></div>
    </div>
  </div>
</section>